import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.timer = setInterval(() => this.refresh(), 3000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  async refresh() {
    try {
      const response = await fetch(this.urlValue, { headers: { Accept: "application/json" } })
      if (!response.ok) return
      const result = await response.json()
      if (this.element.isConnected && result.status !== "pending") {
        clearInterval(this.timer)
        window.Turbo.visit(this.urlValue, { action: "replace" })
      }
    } catch {
      // The status page remains usable through its refresh link when offline.
    }
  }
}
